import React, { lazy, Suspense } from "react";
import Index from "./jsx";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { useDispatch, useSelector } from "react-redux";
import { loginRequestWithToken } from "./store/actions/AuthActions";

const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});

const Preloader = () => (
  <div id="preloader">
    <div className="sk-three-bounce">
      <div className="sk-child sk-bounce1"></div>
      <div className="sk-child sk-bounce2"></div>
      <div className="sk-child sk-bounce3"></div>
    </div>
  </div>
);

function App() {
  const { isAuthenticated, userType, isLoading } = useSelector(
    (store) => store.auth
  );
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const searchParams = new URLSearchParams(location?.search);
  const jwtToken = searchParams.get("jwt_token") || searchParams.get("jwt");
  // Guards against firing the token login twice (React StrictMode / re-renders)
  const tokenLoginStarted = React.useRef(false);

  React.useEffect(() => {
    if (!jwtToken || tokenLoginStarted.current) return;
    tokenLoginStarted.current = true;
    const targetPath = location.pathname;
    dispatch(loginRequestWithToken(jwtToken)).then((res) => {
      const { success, data } = res?.payload || {};
      tokenLoginStarted.current = false;
      // replace: true drops the token from the URL and browser history
      if (success && data?.token) {
        navigate(targetPath, { replace: true });
      } else {
        navigate("/login", { replace: true });
      }
    });
  }, [jwtToken, location.pathname, dispatch, navigate]);

  React.useEffect(() => {
    // Don't redirect while a token login is still in flight
    if (!isAuthenticated && !jwtToken && !isLoading) {
      navigate("/login");
    }
  }, [isAuthenticated, jwtToken, isLoading, navigate]);

  if (jwtToken && !isAuthenticated) {
    return <Preloader />;
  }

  if (isAuthenticated) {
    return (
      <Suspense fallback={<Preloader />}>
        <Index userType={userType} />
      </Suspense>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense fallback={<Preloader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/page-register" element={<SignUp />} />
            <Route path="/page-forgot-password" element={<ForgotPassword />} />
          </Routes>
        </Suspense>
      </div>
    );
  }
}

export default App;
